import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { TimestampToDateMoment } from "../../../../../utils/timestampToDate";
import RenderStatus from "../../../../styles/styledStatus";

import { StyledBreakWord } from "../../../../styles/styledBreakWord";
import { StyledCopy } from "../../../../styles/styledCopy";
import { StyledCol, StyledTableRow } from "../../../../styles/styledTable";

const ExchangeProfitDetailsItem = ({ value, notification, setNotification }) => {
  const { t } = useTranslation("exchangerPage");

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <StyledTableRow
      onClick={(e) => showDetails(e)}
      col="12"
      scroll="auto"
      cursor="pointer"
      className="profit-details-list__row"
      as={NavLink}
      to={`/exchange/${value.id}`}
    >
      <StyledCol
        inline
        data-title="id"
      >
        <CopyToClipboard
          className="stop-event"
          text={value.id}
          onCopy={() => {
            setNotification({
              ...notification,
              visible: true,
              type: "success",
              message: t("profitDetails.table.copied")
            });
          }}
        >
          <StyledBreakWord as="p">
            {value.id} <StyledCopy
            title={t("profitDetails.table.copy")}
            className="icon-light-copy"
          />
          </StyledBreakWord>
        </CopyToClipboard>
      </StyledCol>
      <StyledCol
        inline
        data-title={t("profitDetails.table.client")}
      >
        <StyledBreakWord>
          <p>
            Nickname: {value.pair.user.nickname ?? "--"}
          </p>
          <p>
            E-mail: {value.pair.user.email}
          </p>
        </StyledBreakWord>
      </StyledCol>
      <StyledCol
        data-title={t("profitDetails.table.inService")}
      >
        {value.pair.exchangePair.inService.name}
      </StyledCol>
      <StyledCol
        inline
        data-title={t("profitDetails.table.inAmount")}
      >
        <StyledBreakWord as="p">
          {value.inAmount} {value.pair.exchangePair.inCurrency.asset}
        </StyledBreakWord>
      </StyledCol>
      <StyledCol
        data-title={t("profitDetails.table.outService")}
      >
        {value.pair.exchangePair.outService.name}
      </StyledCol>
      <StyledCol
        inline
        data-title={t("profitDetails.table.outAmount")}
      >
        <StyledBreakWord as="p">
          {value.outAmount} {value.pair.exchangePair.outCurrency.asset}
        </StyledBreakWord>
      </StyledCol>
      <StyledCol
        inline
        data-title={t("profitDetails.table.status")}
      >
        <RenderStatus status={value?.status?.value} />
      </StyledCol>
      <StyledCol data-title={t("profitDetails.table.date")}>
        {TimestampToDateMoment(value.createdAt)}
      </StyledCol>
    </StyledTableRow>
  );
};

export default ExchangeProfitDetailsItem;